var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector104(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 184,
    viewBox: "0 0 292 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6498 0.259766C16.1598 25.6798 11.6998 53.5998 7.7898 83.5798C7.4198 86.3998 6.2198 99.7798 6.0398 102.61L0.799805 181.93C17.9598 157.22 21.7998 153.22 40.0798 137.03C44.5598 133.06 53.3598 126.69 64.3498 120.42C67.6398 118.54 70.9098 116.82 74.1398 115.22C97.2798 103.81 123.89 100.5 150.43 100.82C218.16 101.64 276.25 60.7698 289.93 4.30977C290.26 2.95977 290.56 1.60977 290.83 0.259766",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector104);
export default __webpack_public_path__ + "static/media/vector10-4.a2a621d6740b6ec1d4568e5dcc0cce96.svg";
export { ForwardRef as ReactComponent };